/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import React from 'react'

import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import Icon from '../../packages/kiti/components/shapes/Icon'
import Link from '../actions/Link'
import Loading from '../../packages/kiti/components/helpers/Loading'
import Panel from '../../packages/kiti/components/structure/Panel'
import Text, { SmallText } from '../../packages/kiti/components/presentation/Text'
import Markdown from '../presentation/Markdown'

const Message = ({
  title,
  message,
  icon,
  actionIcon,
  bgColor,
  iconColor,
  color,
  action,
  actionLabel,
  loading,
  actionColor,
  iconSize,
  useMarkdown,
  ...props
}) => {
  color = color || 'dark3'
  if (!title && !message) return false
  return (
    <Panel padding={0.5} noMargin bgColor={bgColor || COLORS.lightTransparent1} noBorder {...props}>
      <Grid align="center" justify="space-between" gutter={0.3} wrap>
        {icon && <Icon color={iconColor || color} name={icon} size={iconSize} />}
        <Col flex={1} style={{ minWidth: 0 }}>
          {useMarkdown ? (
            <Markdown value={title} noMargin color={color} />
          ) : (
            <Text color={color} noMargin>
              {title}
            </Text>
          )}

          <SmallText color={color} size="xsmall">
            {message}
          </SmallText>
        </Col>

        {actionLabel &&
          (!!loading ? (
            <Loading />
          ) : (
            <Link onClick={action} block>
              <Grid gutter={0.2}>
                <Text color={actionColor || COLORS.dark2} size="small" bold>
                  {actionLabel}
                </Text>
                <Icon name={actionIcon || 'BsArrowRightShort'} color={actionColor || COLORS.dark2} />
              </Grid>
            </Link>
          ))}
      </Grid>
    </Panel>
  )
}

export default Message
